// pages/sections/DoneCell.js
// Completion status for review sections where finishing the row is a by-product of an
// action (Stale Jobs / Late Filings decision, Client Quoted Fee submission): a green
// "Done" badge whose tooltip says who and when, plus an admin-only Unmark link.
import React from 'react';

export default function DoneCell({ done, tip, label = 'Done', isAdmin, readOnly, busy, onUnmark }) {
  if (!done) return <span className="rt-cell-muted">—</span>;
  return (
    <span className="rt-done-cell">
      <span className="rt-done" title={tip}>
        <i className="fas fa-check-circle" /> {label}
      </span>
      {isAdmin && onUnmark && (
        <button type="button" className="rt-link" disabled={readOnly || busy} onClick={onUnmark}
                title="Admin: reopen this row (removes the completion; whatever was recorded or sent stays)">
          Unmark
        </button>
      )}
    </span>
  );
}
